var React = require('react');

function BarChart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30.8916 33.8334V17.1667","stroke":"#01C716","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M20.8916 33.8334V7.16675","stroke":"#01C716","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10.8916 33.8333V23.8333","stroke":"#01C716","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

BarChart.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = BarChart;

BarChart.default = BarChart;
